import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const getBank = (banks, bankID) => (
  banks.data.find(b => (`${b.id}` === `${bankID}`))
);

const BankIcon = ({
  bankID,
  banks,
  type,
}) => {
  if (banks.isFetching) {
    return (<span>...</span>);
  }
  const bank = getBank(banks, bankID);
  if (!bank) {
    return (<span>N/A</span>);
  }
  return (<div className={`${bank.code.toLowerCase()} brands ${type || 'round'}`}>
    <span>{bank.shortName || bank.code}</span>
  </div>);
};

BankIcon.propTypes = {
  bankID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  banks: PropTypes.shape({
    data: PropTypes.array,
  }).isRequired,
  type: PropTypes.string,
};

const mapStateToProps = state => ({
  banks: state.banks,
});

export default connect(mapStateToProps)(BankIcon);



// WEBPACK FOOTER //
// ./src/components/BankIcon.jsx